<template>
    <div>
      <!-- Header 区域 -->
      <van-nav-bar fixed title="文章详情" left-arrow   @click-left="$router.back()" />

      <!-- 文章信息区域 -->
      <div class="article-container">
        <!-- 文章标题 -->
        <h1 class="art-title">{{artObj.title}}</h1>

        <!-- 用户信息 -->
        <van-cell center :title="artObj.aut_name" :label="formatDate(artObj.pubdate)">
          <template #icon>
            <img :src="artObj.aut_photo" alt="" class="avatar">
          </template>
          <template #default>
            <div>
                <!-- 关注（用户） -->
              <van-button type="info" size="mini" v-if="artObj.is_followed === true"
              @click="followedFn(true)">已关注</van-button>
              <van-button icon="plus" type="info" size="mini" plain v-else
              @click="followedFn(false)">关注</van-button>
            </div>
          </template>
        </van-cell>

        <!-- 分割线 -->
        <van-divider></van-divider>

        <!-- 文章内容 -->
        <div class="art-content" v-html="artObj.content"></div>

        <!-- 分割线 -->
        <van-divider>End</van-divider>

        <!-- 点赞(文章) -->
        <!-- attitude: -1：五态度， 0-不喜欢， 1-点赞 -->
        <div class="like-box">
          <van-button icon="good-job" type="danger" size="small"
          v-if="artObj.attitude === 1" @click="loveFn(true)">已点赞</van-button>
          <van-button icon="good-job-o" type="danger" plain size="small"
          v-else @click="loveFn(false)">点赞</van-button>
        </div>
      </div>
      <!-- 文章评论 -->
      <CommentList :artObj="artObj"></CommentList>
    </div>
  </template>

<script>
import {
  detailAPI, userFollowedAPI, userUnFollowedAPI
  , unlikeArticleAPI, likeArticleAPI
} from '@/api'
import { timeAgo } from '@/utils/date.js'
import CommentList from './CommentList.vue'
export default {
  data () {
    return {
      artObj: {} // 文章都西昂
    }
  },
  components: { CommentList },
  async created () {
    const res = await detailAPI({
      artId: this.$route.query.art_id
    })
    console.log(res)
    this.artObj = res.data.data
  },
  methods: {
    formatDate: timeAgo,
    // 关注、取关->作者
    async followedFn (bool) {
      if (bool === true) {
        // 用户点在已关注按钮上，业务取关
        this.artObj.is_followed = false
        const res = await userUnFollowedAPI({
          userId: this.artObj.aut_id
        })
        console.log(res)
      } else {
        // 用户点在关注按钮
        this.artObj.is_followed = true
        const res = await userFollowedAPI({
          userId: this.artObj.aut_id
        })
        console.log(res)
      }
    },
    // 点咋、取消点赞
    async loveFn (bool) {
      if (bool === true) {
        // 用户点在了已点在身上
        // 显示点赞按钮
        this.artObj.attitude = 0
        await unlikeArticleAPI({
          artId: this.artObj.art_id
        })
      } else {
        this.artObj.attitude = 1
        await likeArticleAPI({
          artId: this.artObj.art_id
        })
      }
    }
  }
}
</script>

  <style scoped lang="less">
  .article-container {
    padding: 10px;
    margin-top: 46px;
  }
  .art-title {
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
  }

  .art-content {
    font-size: 12px;
    line-height: 24px;
    width: 100%;
    overflow-x: scroll;
    word-break: break-all;
      /deep/ img{
          width: 100%;
        }
      /deep/ pre {
          white-space: pre-wrap;
          word-wrap: break-word;
      }
  }

  .van-cell {
    padding: 5px 0;
    &::after {
      display: none;
    }
  }

  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f8f8f8;
    margin-right: 5px;
    border: none;
  }

  .like-box {
    display: flex;
    justify-content: center;
  }
  </style>
